import styled, { css } from 'styled-components';

import { termsBgConfig } from './helpers';

interface IScTermsAndConditions {
  isOpen: boolean;
  withOpenBg?: boolean;
  isMobile?: boolean;
  bgScheme?: keyof typeof termsBgConfig;
}

export const ScTermsAndConditions = styled.div<IScTermsAndConditions>`
  text-transform: none;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  max-width: 600px;

  ${({ withOpenBg }) =>
    withOpenBg &&
    css`
      padding: 12px;
    `}

  ${({ theme, withOpenBg, isOpen, bgScheme }) =>
    withOpenBg &&
    isOpen &&
    css`
      position: relative;
      z-index: 1;
      max-width: 400px;
      margin-top: 12px;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 16px;
        background: ${termsBgConfig[bgScheme || 'gray'](theme)};
        z-index: -1;
      }

      @media (hover: hover) {
        &:hover {
          opacity: 0.8;
          transition: opacity 0.3s ease-in-out;
        }
      }
    `}

  & > .terms__title {
    cursor: pointer;
    display: flex;
    justify-content: center;
    gap: 8px;

    & img {
      width: 16px;
      transform: rotate(${({ isOpen }) => (isOpen ? '180deg' : '0deg')});

      transition: transform 200ms;
    }
  }

  & .terms {
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows ${({ isOpen }) => (isOpen ? '0s' : '0.2s')} ease;

    &-content {
      overflow: hidden;
      opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
      transition: opacity ${({ isOpen }) => (isOpen ? '0.4s' : '0.2s')} ease;
      & ol {
        text-align: left;
        margin-top: 8px;
        list-style: none;
        & li {
          list-style: none;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
        & ul {
          padding-left: 24px;
          margin-top: 6px;
          list-style: disc;
          & li {
            list-style: disc;
          }
        }
      }
    }
  }
`;
